export default function tags(state = [], action) {
    switch (action.type) {
        case 'ADD_CURRENT':
            return {
                ...state,
                tags: action.tags,
            }
        default:
            return state;
    }
}
